import React from "react";

const CompleteOrderShimmer = () => {
  return (
    <section className="relative min-h-screen bg-slate-50">
      {/* Customer Card */}
      <div className="mt-8 mx-auto w-full max-w-7xl bg-white border border-gray-200 rounded-xl p-4 shadow-sm flex items-center gap-4">
        <div className="w-12 h-12 rounded-md shimmer" />
        <div className="flex flex-col gap-2">
          <div className="h-4 w-40 shimmer rounded" />
          <div className="h-3 w-32 shimmer rounded" />
        </div>
      </div>

      {/* Meal Details */}
      <div className="mt-8 mx-auto w-full max-w-7xl bg-white border border-gray-200 rounded-xl p-6 shadow-sm">
        <div className="flex items-center gap-4">
          <div className="w-12 h-12 shimmer rounded-md" />
          <div className="flex flex-col gap-2">
            <div className="h-4 w-36 shimmer rounded" />
            <div className="h-4 w-20 shimmer rounded" />
          </div>
        </div>

        {/* Timing + Date */}
        <div className="mt-4 flex gap-4">
          <div className="h-6 w-24 shimmer rounded-full" />
          <div className="h-4 w-28 shimmer rounded" />
        </div>

        <div className="border-b border-gray-200 mt-6 mb-4"></div>

        {/* Order Summary */}
        <div className="space-y-4">
          <div className="flex justify-between">
            <div className="h-4 w-24 shimmer rounded" />
            <div className="h-4 w-16 shimmer rounded" />
          </div>

          {/* Extra items table */}
          <div className="rounded-lg border border-gray-200 overflow-hidden">
            <div className="bg-gray-50 p-4 flex justify-between">
              <div className="h-4 w-28 shimmer rounded" />
              <div className="h-4 w-20 shimmer rounded" />
            </div>

            {[1, 2, 3].map((i) => (
              <div
                key={i}
                className="flex justify-between items-center px-4 py-3 border-t"
              >
                <div className="h-4 w-40 shimmer rounded" />
                <div className="h-4 w-16 shimmer rounded" />
              </div>
            ))}

            {[1, 2, 3].map((i) => (
              <div
                key={`f-${i}`}
                className="flex justify-between items-center px-4 py-3 bg-gray-50 border-t"
              >
                <div className="h-4 w-36 shimmer rounded" />
                <div className="h-4 w-20 shimmer rounded" />
              </div>
            ))}
          </div>
        </div>

        {/* Address */}
        <div className="mt-6 flex gap-2">
          <div className="h-5 w-5 shimmer rounded" />
          <div className="h-4 w-full max-w-md shimmer rounded" />
        </div>

        {/* Buttons */}
        <div className="flex flex-col md:flex-row gap-4 md:justify-between mt-8">
          <div className="h-11 w-full md:w-48 bg-gray-300 rounded-xl" />
          <div className="h-11 w-full md:w-48 bg-gray-300 rounded-xl" />
        </div>
      </div>
    </section>
  );
};

export default CompleteOrderShimmer;
